import { useState, useEffect } from 'react';

/**
 * Custom hook to detect device type
 */
export const useDeviceDetection = () => {
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isAndroidDevice = /android/i.test(userAgent);
    const isiOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isMobileDevice = /Mobi|Android/i.test(userAgent);

    setIsAndroid(isAndroidDevice);
    setIsIOS(isiOSDevice);
    setIsMobile(isMobileDevice);
  }, []);

  return { isAndroid, isIOS, isMobile };
};
